import client from "../httpClient";
import uiStore from "../../store/UiStore";

const devicesListService = {
  AddDeviceTags: () => {
    return client.Put("devicesList", ["devicesList"], {}, {});
  },
  GetDevicesList: () => {
    const response = client.Get(
      "devicesList",
      ["devicesList"],
      {},
      { staleTime: 6000 * 30 , cacheTime: 0}
    );
    if (response.isSuccess) {

     const devicesList =  response.data.reduce((acc: any, device: any) => {
            const { id, ...deviceData } = device;
            acc[id] = deviceData;
            return acc;
      }, {});
      uiStore.setDeviceList(devicesList);
      return response;

    } else {
      return { ...response, data: [] };
    }
  },
};

export default devicesListService;
